export default __webpack_public_path__ + "static/media/people.45c3fd11.svg";